import React, { useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { Typography, useMediaQuery } from "@mui/material";
import { numFormatter } from "../../util/common";
import moment from "moment";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiCircularProgress-root": {
      color: "#554c4c9e",
      zIndex: 1,
    },
  },
  activeCircular: {
    color: "#fff !important",
    zIndex: 10,
  },
  title: {
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "24px",
    lineheight: "29px",
    color: "#FFFFFF",
  },
}));

// export const options = {
//   responsive: true,
//   plugins: {
//     legend: {
//       position: "top",
//     },
//     title: {
//       display: true,
//       text: "Chart.js Line Chart",
//     },
//   },
// };

// const labels = [
//   "08-Sep-22",
//   "07-Sep-22",
//   "06-Sep-22",
//   "05-Sep-22",
//   "04-Sep-22",
//   "03-Sep-22",
//   "02-Sep-22",
//   "01-Sep-22",
//   "31-Aug-22",
//   "30-Aug-22",
// ].reverse();

// const data1 = [
//   "21518295",
//   "21444920",
//   "21362717",
//   "21278530",
//   "21191999",
//   "21106651",
//   "21028741",
//   "20949189",
//   "20874614",
//   "20796619",
//   "20718034",
//   "20624526",
//   "20526404",
//   "20431713",
//   "20314670",
// ].reverse();
// export const data = {
//   labels,
//   datasets: [
//     {
//       label: "Song Views",
//       data: data1,
//       borderColor: "#E14084",
//       backgroundColor: "rgba(255, 99, 132, 0.5)",
//     },
//   ],
// };

export function PerformanceGraph({ songName, songPerformance, totalStreams }) {
  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width:768px)");
  const options = {
    responsive: true,
    aspectRatio: isMobile ? 1 : 3,
    tooltips: {
      mode: "label",
      intersect: false,
    },
    color: "#FFF",
    scales: {
      x: {
        ticks: {
          callback: function (value, index, ticks) {
            if (index % 2 == 0) return;
            return moment(songPerformance.labels[index]).format("DD MMM");
          },
          color: "#ffffff",
        },
      },
      y: {
        ticks: {
          callback: function (value, index, ticks) {
            return numFormatter(value);
          },
          color: "#ffffff",
        },
      },
    },
  };

  return (
    <Box style={{ backgroundColor: "#242033", padding: "30px", width: "100%" }}>
      <Typography variant="p" className={classes.title}>
        {" "}
        {songName} completes {totalStreams} + streams
      </Typography>
      <Line options={options} data={songPerformance} />
    </Box>
  );
}

export default React.memo(PerformanceGraph);
